import {Injectable} from "@angular/core";
import {CustomHttp} from "../core/http-custom/http-custom.service";
import {Observable} from 'rxjs';

import {Role} from "../role/role.model";


@Injectable()
export class RolesService {

  constructor(private _http: CustomHttp) {
  }

  public getAllRoles(): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/allRoles`);
  }

  public getAllConfirmedRoles(): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/confirmedRoles`);
  }

  public getRolesByTargetGroup(targetGroup: string, isConfirmedBySolarluxAdmin: boolean): Observable<Array<any>> {
    return this._http.post(`/apps/umng/api/roles/customer/roles/${targetGroup}`,
    {
      customerCategory: targetGroup,
      confirmedByAdmin: isConfirmedBySolarluxAdmin
    });
    }


  public getRolesByTargetGroupAndRoleType(targetGroup: string, targetGroupRoleType: string): Observable<Array<any>> {
      return this._http.get(`/apps/umng/api/roles/customer/roles/${targetGroup}/${targetGroupRoleType}`);
  }

  public getAssignedStandardCustomerRoles(customerNumber: string): Observable<Array<any>> {
        return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}/targetGroupRoleType/Standard`);
    }

  public getAllManagedRoles(): Observable<Array<any>> {
       return this._http.get(`/apps/umng/api/roles/managedRoles`);
  }

  /**
  * Post request for validation of AppMangerRoles
  **/
  public validateAppManagerRoles(roles: Array<Role>): Observable<any> {
    return this._http.post(`/apps/umng/api/roles/validateAppManagerRoles`, roles);
  }

  public getUserRolesWithoutCMS(userId: number): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/userRoles/${userId}`);
  }

  // with CMS
  public getAllCustomerRoles(customerNumber: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}?withCMS=true&withAssignableRoles=false`);
  }

  // without CMS
  public getAssignedCustomerRoles(customerNumber: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}?withCMS=false&withAssignableRoles=false`);
  }

  public getAssignableCustomerRoles(customerNumber: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}?withCMS=false&withAssignableRoles=true`);
  }

  public getAssignedCustomerRolesForNewTargetGroup(customerNumber: string, newTargetGroup: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}?withCMS=false&withAssignableRoles=false&newTargetGroup=${newTargetGroup}`);
  }

  public getAssignableCustomerRolesForNewTargetGroup(customerNumber: string, newTargetGroup: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/customer/${customerNumber}?withCMS=false&withAssignableRoles=true&newTargetGroup=${newTargetGroup}`);
  }

  public getDefaultRolesForTargetGroup(targetGroup: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/targetGroup/${targetGroup}?withAssignableRoles=false`);
  }

  public getAssignableRolesForTargetGroup(targetGroup: string): Observable<Array<any>> {
    return this._http.get(`/apps/umng/api/roles/targetGroup/${targetGroup}?withAssignableRoles=true`);
  }

}
